import PageHeader from "../components/common/PageHeader";
import { useEffect, useRef, useCallback } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import GoToTop from "../helpers/GoToTop";
import MetaData from "../helpers/MetaData";
import { useForm, useFieldArray } from "react-hook-form";
import ApiService from "../api/ApiService";
import notification from "../helpers/notification";
import ReCAPTCHA from "react-google-recaptcha";
import { useContext } from "react";
import AppContext from "../context/AppContext.js";
import AboutYatras from "../components/yatras/AboutYatras";
import YatrasCardWrap from "../components/yatras/YatrasCardWrap.jsx";
import moment from "moment";
import { MdClose } from "react-icons/md";
import { MdOutlineClose } from "react-icons/md";

import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

var preRegisterYatras = [
    {
        title: "Sri Dham|Mayapur",
        image: "/images/yatras/mayapur-card-min_1.webp",
        description:
            "Join us for a life-changing experience to the birthplace of Lord Chaitanya Mahaprabhu and the spiritual headquarters of the Hare Krishna Movement.",
    },
    {
        title: "Jagannath|Puri",
        image: "/images/yatras/jagannath-card-min.webp",
        description:
            "Join us as we make way to the courtyard of the Lord of the Universe, Puri where Lord Jagannath, his brother Balbhadra and sister Subhadra reside. ",
        register: "0",
    },
    {
        title: "Tirupati|Balaji",
        image: "/images/yatras/tirupati-balaji-card-min_1.webp",
        description: "Join us to pay obeisances to Lord Venkateswara at the Tirupati Balaji temple in the Tirumala Hills of Andhra Pradesh.",
        register: "0",
    },
    {
        title: "Kartik|Yatra",
        image: "/images/yatras/kartik-yatra-card-min-2.webp",
        description:
            "ISKCON of Attapur celebrates the holy month of Kartik by organising a special Yatra  for devotees that helps deepen their connection with Hari. ",
        register: "0",
    },
];

const expiry = process.env.REACT_APP_OTPEXPIRY;
let timer = null;

const Yatras = () => {
    const { setUser, setToken, user } = useContext(AppContext);
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
    } = useForm({
        defaultValues: {
            relatives: [],
            noOfInfants: "0",
        },
    });
    const recaptchaRef = useRef();
    const payBtnRef = useRef();

    const [loginPopup, setLoginPopup] = useState(false);

    if (user) {
        localStorage.removeItem("token");
        setUser(null);
        setToken(null);
        navigate("/yatras");
        localStorage.removeItem("icsmob");
        localStorage.removeItem("ics_mob");
        localStorage.removeItem("ics_id");
        localStorage.removeItem("multiplesevatype");
        localStorage.removeItem("multiplesevaPrice");
        localStorage.removeItem("multiplesevaName");
        localStorage.removeItem("ics_number");
        localStorage.removeItem("ics_all_data");
    }

    const [show, setShow] = useState(false);
    const [selectedYatra, setSelectedyatra] = useState(null);
    const [customAmount, setCustomAmount] = useState("");
    const [Yatras, setYatras] = useState([]);
    const [top, setTop] = useState(0);

    const { fields, append, remove, replace } = useFieldArray({ control, name: "relatives" });

    const [otpSent, setOtpSent] = useState(false);
    const [number, setNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [otpExp, setOtpExp] = useState(expiry);
    const [resendtimes, setResendTimes] = useState(0);
    const [showresendlink, setShowResendLink] = useState(false);
    const [showTimer, setShowTimer] = useState(true);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [inputValue, setInputValue] = useState("");

    function getTime(time) {
        return Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2);
    }

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    const yatraRef = useCallback((node) => {
        if (node) {
            let headerHeight;
            if (window.innerWidth > 1000) {
                headerHeight = 80;
            } else if (window.innerWidth > 600) {
                headerHeight = 90;
            } else {
                headerHeight = 50;
            }
            setTop(node?.offsetTop - headerHeight);
        }
    });

    const handlePreRegister = (yatra) => {
        setSelectedyatra(yatra);
        setShow(true);
        reset();
        setCustomAmount("");
        setInputValue("");
    };

    const handleModalHide = () => {
        setShow(false);
        setCustomAmount("");
        reset({
            name: "",
            email: "",
            location: "",
            age: "",
            gender: "",
            preacherName: "",
            phone: "",
        });
    };
    const handleInputChange = (event) => {
        // console.log("yyyy");

        setInputValue(event.target.value);
    };
    const onFormSubmit = async (data) => {
        console.log("data", data);

        const token = await recaptchaRef.current.executeAsync();
        data.token = token;

        const paymentAmount = customAmount || 1000;

        try {
            const res = await ApiService.createYatraEnquiry({
                ...data,
                yatraName: `${selectedYatra?.title.split("|")[0]} ${selectedYatra?.title.split("|")[1]}`,
                amount: paymentAmount,
                PaidAmount: paymentAmount,
            });

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY,
                currency: res.currency,
                amount: res.amount,
                name: process.env.REACT_APP_PROJECT_NAME,
                description: "Help Us to Help the Society",
                image: `${process.env.REACT_APP_S3_URL}/assets/img/logo.png`,
                order_id: res.id,
                handler: function (response) {
                    notification("success", "Payment successful!");
                    const yatraTitle = selectedYatra?.title.split("|")[0];
                    navigate(`/yatra-thank-you-page/${res.yatra_id}`);
                },
                prefill: {
                    name: data?.name,
                    email: data?.email,
                    contact: data?.phone,
                },
                notes: { type: "yatra" },
                theme: { color: "#FFD370" },
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error(error);
            notification("error", error.response?.data?.message || "Payment failed");
        }
    };

    const [meta, setMeta] = useState(null);
    const fetchMeta = async (pagename) => {
        try {
            let res = await ApiService.fetchMetaData(pagename);
            setMeta(res);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        loadScript("https://checkout.razorpay.com/v1/checkout.js");
    }, [user]);

    useEffect(() => {
        fetchMeta("yatras");
    }, []);

    const fetchYatras = async () => {
        try {
            const res = await ApiService.fetchYatras();
            setYatras(res);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchYatras();
    }, []);

    const handleSendOtp = async () => {
        let titleYatra = selectedYatra.title;
        let data = {
            number,
            titleYatra,
        };

        if (timer) {
            clearInterval(timer);
        }
        if (number.length >= 10) {
            try {
                setBtnDisabled(true);
                const res = await ApiService.sendOtpYatra({ number, titleYatra });
                notification("success", res.message);
                setBtnDisabled(false);
                timer = setInterval(() => {
                    setOtpExp((prev) => prev - 1);
                }, 1000);
                setOtpSent(true);
            } catch (err) {
                console.log(err);
                if (err.response.status === 400) {
                    notification("warning", err.response.data.message);
                    setShow(true);
                } else {
                    notification("error", err.response.data.message);
                }
                setBtnDisabled(false);
            }
        } else {
            notification("warning", "Please Enter Valid Number");
            setBtnDisabled(false);
        }
    };

    const handleLogin = async () => {
        if (otp.length >= 6) {
            try {
                let titleYatra = selectedYatra.title;
                let data = {
                    number,
                    otp,
                    titleYatra,
                };

                const res = await ApiService.loginUserYatra(data);
                localStorage.setItem(`token`, res.token);
                setToken(res.token);
                setLoginPopup(false);
                setShow(true);
                notification("success", res.message);
                setOtpSent(false);
                reset({
                    phone: number,
                });
                setOtp("");
            } catch (err) {
                notification("error", err.response.data.message);
            }
        } else {
            notification("warning", "Please Enter Valid OTP");
        }
    };

    function setCookie(name, value) {
        let expires = "";
        let date = new Date();
        date.setTime(date.getTime() + 1 * 60 * 1000);
        expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    const resendOtp = () => {
        setShowResendLink(false);

        if (getCookie("limitReached2")) {
            notification("warning", "Resend OTP limit has been reached!");
            setResendTimes(0);
            setShowTimer(false);
        } else {
            if (resendtimes < 2) {
                setOtpExp(expiry);
                handleSendOtp();
                setResendTimes((prev) => prev + 1);
            } else {
                setCookie("limitReached2", true);
                notification("warning", "Resend OTP limit has been reached!");
                setShowTimer(false);
            }
        }
    };

    const handleHideModal = () => {
        setLoginPopup(false);
    };

    const PhoneCheck = (e) => {
        const val = e.target.value.length;

        if (val === 10) {
            setNumber(e.target.value);
            setLoginPopup(true);
            setShow(false);
        }
    };

    useEffect(() => {
        if (otpExp === 0) {
            setShowResendLink(true);
            clearInterval(timer);
            setOtpExp(expiry);
        }
    }, [otpExp, expiry]);

    const handleRemove = (index) => {
        remove(index);
    };

    return (
        <>
            <MetaData title="Yatras - ISKCON of Attapur" />
            <PageHeader title="Yatras" imgSrc="/images/page-header/03.webp" />
            <AboutYatras />

            <section className="vrindavan-card" ref={yatraRef}>
                <div className="container">
                    {!(Yatras.length > 0) ? (
                        <YatrasCardWrap />
                    ) : (
                        Yatras.map((Yatra, index) => {
                            return (
                                <>
                                    {Yatra.status === true ? (
                                        <div key={index} className="vrindavan-wrap mt-4">
                                            <div className="row">
                                                <div className="col-lg-5">
                                                    <figure className="yatra-fig">
                                                        <img src={`${process.env.REACT_APP_S3_URL}/uploads/yatra/${Yatra?.image}`} alt="" />
                                                    </figure>
                                                </div>
                                                <div className="col-lg-7">
                                                    <div className="heading my-auto">
                                                        <div className="mb-md-2 mt-md-0 mt-4">
                                                            <h2 className="head-2">{Yatra?.title} </h2>
                                                        </div>
                                                        <div className="date-div mb-md-2">
                                                            <figure className="date-up">
                                                                <img src="/images/yatras/up.svg" alt="" />
                                                            </figure>
                                                            <h5>
                                                                {moment(Yatra.startDate).format("DD/MM/YYYY") === moment(Yatra.endDate).format("DD/MM/YYYY")
                                                                    ? moment(Yatra.startDate).format("dddd, D MMMM YYYY")
                                                                    : moment(Yatra.startDate).format("dddd, D MMMM") + " - " + moment(Yatra.endDate).format("dddd, D MMMM YYYY")}
                                                            </h5>
                                                            <figure className="date-down">
                                                                <img src="/images/yatras/down.svg" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div>
                                                            <p style={{ textAlign: 'justify' }}>{Yatra?.description}</p>

                                                            <p className="my-1">Join us for the {Yatra?.title}</p>
                                                            <p className="my-1">
                                                                Between{" "}
                                                                {moment(Yatra.startDate).format("DD/MM/YYYY") === moment(Yatra.endDate).format("DD/MM/YYYY")
                                                                    ? moment(Yatra.startDate).format("dddd, D MMMM YYYY")
                                                                    : moment(Yatra.startDate).format("dddd, D MMMM") + " - " + moment(Yatra.endDate).format("dddd, D MMMM YYYY")}
                                                            </p>
                                                        </div>

                                                        <>
                                                            {
                                                                Yatra.androidCalenderLink === "1" ? (
                                                                    <button
                                                                        onClick={() =>
                                                                            handlePreRegister({
                                                                                minPrice: Yatra?.minAmount,
                                                                                title: Yatra?.title,
                                                                                image: `${process.env.REACT_APP_S3_URL}/uploads/yatra/${Yatra?.image}`,
                                                                            })
                                                                        }
                                                                        className="custom-btn-cls box-hover my-4"
                                                                        style={{ width: "310px" }}
                                                                    >
                                                                        REGISTER
                                                                    </button>
                                                                ) : (
                                                                    ""
                                                                )
                                                            }
                                                        </>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </>
                            );
                        })
                    )}
                </div>
            </section>

            {/* Registration Modal */}
            <Modal centered show={show} onHide={handleModalHide}>
                <div className="modal-wrap ">
                    <button className="btn close-svg" onClick={handleModalHide}>
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 16 16"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.116 8l-4.558 4.558.884.884L8 8.884l4.558 4.558.884-.884L8.884 8l4.558-4.558-.884-.884L8 7.116 3.442 2.558l-.884.884L7.116 8z"
                            ></path>
                        </svg>
                    </button>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="pop-up-form">
                                <div className="pop-up-top">
                                    <div className="heading">
                                        <h2 className="head-2">{selectedYatra?.title.split("|")[0]}</h2>
                                        <h2 className="head-1">{selectedYatra?.title.split("|")[1]}</h2>
                                    </div>
                                    <figure className="hare-krishna-logo-fig">
                                        <img src="/images/modal/hare-krishna-logo.svg" alt="" />
                                    </figure>
                                </div>

                                <p>{selectedYatra?.description}</p>

                                <form action="" className="mt-3 mt-sm-0" onSubmit={handleSubmit(onFormSubmit)} autoComplete="off">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="label-input-wrap">
                                                <label htmlFor="name">Name</label>
                                                <input
                                                    autoComplete="off"
                                                    type="text"
                                                    id="name"
                                                    onKeyUpCapture={handleInputChange}
                                                    {...register("name", { required: true })}
                                                    onKeyPress={(event) => {
                                                        if (/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {errors.name?.type === "required" && <small className="error">This is required</small>}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="label-input-wrap">
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    autoComplete="off"
                                                    type="text"
                                                    id="email"
                                                    {...register("email", {
                                                        required: true,
                                                        pattern: {
                                                            value:
                                                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                            message: "Please enter a valid email",
                                                        },
                                                    })}
                                                />
                                                {errors.email?.type === "required" && <small className="error">This is required</small>}
                                                {errors.email && <small className="text-danger error">{errors.email.message}</small>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="label-input-wrap">
                                                <label htmlFor="phone">Phone</label>
                                                <input
                                                    type="text"
                                                    id="phone"
                                                    autoComplete="off"
                                                    // onKeyUp={PhoneCheck}
                                                    maxLength={10}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    {...register("phone", {
                                                        required: true,
                                                        pattern: {
                                                            value: /^[6-9]\d*$/,
                                                            message: "Please provide valid phone number",
                                                        },
                                                        minLength: {
                                                            value: 10,
                                                            message: "Phone must be minimum 10 digit",
                                                        },
                                                        maxLength: {
                                                            value: 10,
                                                            message: "Phone must be maximum 10 digit",
                                                        },
                                                    })}
                                                />
                                                {errors.phone?.type === "required" && <small className="error">This is required</small>}
                                                {errors.phone && <small className="error">{errors.phone.message}</small>}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="label-input-wrap">
                                                <label htmlFor="location">City</label>
                                                <input autoComplete="off" type="text" id="location" {...register("location", { required: true })} />
                                                {errors.location?.type === "required" && <small className="error">This is required</small>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="label-input-wrap">
                                                <label htmlFor="gender">Gender</label>
                                                <select id="gender" {...register("gender", { required: true })}>
                                                    <option value="">Select a gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </select>
                                                {errors.gender?.type === "required" && <small className="error">This is required</small>}
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="label-input-wrap">
                                            <label htmlFor="preacherName">Preacher Name:</label>
                                            <select
                                                id="preacherName"
                                                {...register("preacherName")}
                                            >
                                                <option value="">Select a preacher</option>
                                                <option value="Bhavamaya Nityananda Das">Bhavamaya Nityananda Das</option>
                                                <option value="Chaitanya Avatar Das">Chaitanya Avatar Das</option>
                                                <option value="Ishan Gaur Das">Ishan Gaur Das</option>
                                                <option value="Hridaya Yajna Das">Hridaya Yajna Das</option>
                                                <option value="Pramod Gopinath Das">Pramod Gopinath Das</option>
                                                <option value="Anantha Achintya Das">Anantha Achintya Das</option>
                                                <option value="Mahapati Ram Das">Mahapati Ram Das</option>
                                                <option value="Narottam Priya Das">Narottam Priya Das</option>
                                                <option value="Nitai Jivana Das">Nitai Jivana Das</option>
                                                <option value="Nitai Madhava Das">Nitai Madhava Das</option>
                                                <option value="Radhakant Das">Radhakant Das</option>
                                                <option value="Shantivardhan Das">Shantivardhan Das</option>
                                                <option value="Sitaram Das">Sitaram Das</option>
                                                <option value="Sri Sudama Das">Sri Sudama Das</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="row">
                                            <div className="label-input-wrap col-12 mb-0">
                                                <label htmlFor="">Add Family Members Participating in the Yatra</label>
                                            </div>
                                            <div className="label-input-wrap col-6">
                                                <button
                                                    type="button"
                                                    className="custom-btn-cls add-relative-btn"
                                                    onClick={() => {
                                                        append({ inputName: "relativeName" });
                                                    }}
                                                    style={{
                                                        lineHeight: "19px",
                                                        background: "#f3f3f3",
                                                        color: "#0f0e0e",
                                                    }}
                                                >
                                                    <b style={{ fontSize: "20px" }}>+</b> Add Adults (Above 9 years)
                                                </button>

                                                <div className="label-input-wrap">
                                                    <div className="row">
                                                        <div className="col-12 form-part">
                                                            <label>Adult Name</label>
                                                            <input
                                                                type="text"
                                                                autoComplete="off"
                                                                defaultValue={inputValue}
                                                                placeholder="Name of the person"
                                                                {...register(`relatives.0.relativeName`)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {fields.map((item, index) => {
                                                    if (item.inputName === "relativeName") {
                                                        return (
                                                            <div className="row" key={item.id}>
                                                                <div className="col-9 form-part">
                                                                    <label htmlFor={`relatives.${index + 1}.relativeName`}>Adult Name</label>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Name of the person"
                                                                        {...register(`relatives.${index + 1}.relativeName`)}
                                                                    />
                                                                </div>
                                                                <div className="col-2 mt-4 mb-lg-0">
                                                                    <button type="button" onClick={() => handleRemove(index)} className="form-close-btn">
                                                                        <MdClose />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>

                                            <div className="label-input-wrap col-6">
                                                <button
                                                    type="button"
                                                    className="custom-btn-cls add-relative-btn"
                                                    onClick={() => {
                                                        append({ inputName: "children" });
                                                    }}
                                                    style={{
                                                        lineHeight: "19px",
                                                        background: "#f3f3f3",
                                                        color: "#0f0e0e",
                                                    }}
                                                >
                                                    <b style={{ fontSize: "20px" }}>+</b> Add Children (Below 9 years)
                                                </button>

                                                <div className="label-input-wrap">
                                                    <div className="row">
                                                        <div className="col-12 form-part">
                                                            <label>Child Name</label>
                                                            <input
                                                                autoComplete="off"
                                                                type="text"
                                                                placeholder="Name of the Child"
                                                                {...register(`relatives.1.children`)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {fields.map((item, index) => {
                                                    return (
                                                        <>
                                                            {item.inputName == "children" && (
                                                                <div className="row" key={item.id}>
                                                                    <div className="col-9 form-part">
                                                                        <label htmlFor="Name">Child Name </label>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Name of the Child"
                                                                            {...register(`relatives.${index}.Name`)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-2 mt-4 mb-lg-0">
                                                                        <button type="button" onClick={() => handleRemove(index)} className="form-close-btn">
                                                                            <MdClose />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        <div className="label-input-wrap">
                                            <label htmlFor="childPeople">Infant ( Below 2 years)</label>
                                            <select id="childPeople" {...register("noOfInfants")}>
                                                <option value="">Select no. infant</option>
                                                {Array.from(Array(5).keys(), (val) => val + 0).map((val) => (
                                                    <option key={val} value={val}>
                                                        {val}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="label-input-wrap">
                                            <label htmlFor="customAmount">Enter Amount (Rs.)</label>
                                            <input
                                                type="number"
                                                id="customAmount"
                                                value={customAmount}
                                                onChange={(e) => setCustomAmount(e.target.value)}
                                                placeholder="Enter amount to pay"
                                                min="1"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} ref={recaptchaRef} size="invisible" />
                                    </div>

                                    <div className="pop-form-btn">
                                        <button className="box-hover" type="submit">
                                            {customAmount
                                                ? `Register and Pay Booking Amount of Rs. ${customAmount}`
                                                : `Register and Pay Booking Amount of Rs. `
                                            }
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Login Modal */}
            <Modal centered show={loginPopup} onHide={handleHideModal}>
                <div className="auth-modal">
                    <button className="btn close-svg" onClick={handleHideModal}>
                        <MdOutlineClose />
                    </button>
                    <div className="row align-items-center">
                        <div className="col-md-6 d-sm-block d-none pe-md-0">
                            <div className="popup-left-side">
                                <figure className="bg_img">
                                    <img src="/images/common/bg-line.jpg" alt="" />
                                </figure>
                                <div className="left-content">
                                    <h4>Login</h4>
                                    <div className="main-content">
                                        <h3>
                                            Log-in to save your details, view donation history and <span> download 80G certificate </span> conveniently.
                                        </h3>
                                    </div>
                                </div>
                                <figure className="popup-img">
                                    <img src="/images/modal/hare-krishna-logo.svg" alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-md-6 ps-md-0">
                            {otpSent ? (
                                <div className="pop-up-form">
                                    <div className="pop-up-top">
                                        <div className="heading">
                                            <h2 className="head-2">OTP Verification</h2>
                                        </div>
                                    </div>
                                    <p>Enter the OTP sent to +91 {number} and on your registered mail id.</p>
                                    <form action="" className="mt-3 mt-sm-0" autoComplete="off">
                                        <div className="row align-items-center">
                                            <div className="col-12">
                                                <div className="label-input-wrap">
                                                    <input
                                                        type="tel"
                                                        id="otp"
                                                        name="otp"
                                                        value={otp}
                                                        onChange={(e) => setOtp(e.target.value)}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        minLength={6}
                                                        maxLength={6}
                                                        placeholder="Enter OTP"
                                                    />
                                                </div>
                                                {!showresendlink && showTimer && (
                                                    <div className="time-wrap">
                                                        <p className="mb-0">Resend OTP in</p>
                                                        <span className="timer_span d-inline-block">{getTime(otpExp)}s</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="pop-form-btn">
                                            <button className="box-hover" type="button" onClick={handleLogin}>
                                                Verify
                                            </button>
                                        </div>
                                        {showresendlink && (
                                            <div className="time-wrap mt-4">
                                                <p className="mb-0">Not yet received OTP?</p>
                                                <button onClick={resendOtp} type="button">
                                                    Resend OTP
                                                </button>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            ) : (
                                <div className="pop-up-form">
                                    <div className="pop-up-top">
                                        <div className="heading">
                                            <h2 className="head-2">Login</h2>
                                        </div>
                                    </div>
                                    <p>We will send you an OTP on this mobile number and on your registered mail id.</p>
                                    <form action="" className="mt-3 mt-sm-0">
                                        <div className="row align-items-center m-0">
                                            <div className="col-12 px-0">
                                                <div className="label-input-wrap">
                                                    <input
                                                        type="tel"
                                                        id="number"
                                                        name="number"
                                                        placeholder="Enter Mobile Number"
                                                        defaultValue={number}
                                                        readOnly
                                                        required
                                                        onChange={(e) => setNumber(e.target.value)}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        minLength={10}
                                                        maxLength={10}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`pop-form-btn ${btnDisabled ? "disabled" : ""}`}>
                                            <button className="box-hover" type="button" onClick={handleSendOtp} disabled={btnDisabled}>
                                                Get OTP
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
            <GoToTop top={top} />
        </>
    );
};

export default Yatras;